import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ApiService } from '../../../core/services/ApiService.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { Plan } from '../../../models/Plan.model';


@Component({
  selector: 'app-planes',
  imports: [
    CommonModule
  ],
  templateUrl: './planes.component.html',
  styleUrl: './planes.component.scss'
})
export class PlanesComponent {

  planes: Plan[] = []

  isMediumScreen: boolean = false

  constructor(
    private router: Router,
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.getPlanes()
      this.getSizeScreen()
    }
  }

  getPlanes() {
    this.apiService.useApiServive(Plan.planes()).subscribe({
      next: (resp:any) => {
        let planes_disponibles = resp.datos.filter((p:Plan) =>p.id_planes != 1)
        this.planes.push(planes_disponibles.find((p:Plan) =>p.id_planes == 3))
        this.planes.push(planes_disponibles.find((p:Plan) =>p.id_planes == 2)) // Plan Premiun
        this.planes.push(planes_disponibles.find((p:Plan) =>p.id_planes == 4))
      },
      error: (error) => {
      }
    })
  }

  /**
 * @method getSizeScreen: Método para verificar el tamaño de la pantalla.
 */
  getSizeScreen() {
    if(isPlatformBrowser(this.platformId)){
      try {
        const width = window.innerWidth;
        if(width > 991) {
          this.isMediumScreen = false
        } else {
          this.isMediumScreen = true
        }
      } catch (error) {}
     
      addEventListener("resize", (event) => {
          var width = window.innerWidth;
  
          if(width > 991) {
            this.isMediumScreen = false
          } else {
            this.isMediumScreen = true
          }
      });
    }
  }

  planSelected(plan: Plan) {
    if ( plan.id_planes == 3 ) {
      window.open('https://payp.page.link/zc7Wc', '_blank')
    } else if ( plan.id_planes == 2 ) {
      window.open('https://payp.page.link/7ZrDL', '_blank')
    } else if ( plan.id_planes == 4 ) {
      window.open('https://payp.page.link/WL9zk', '_blank')
    }
  }

}
